<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="教师信息">
              <a-input placeholder="请输入姓名/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>

          <a-col :span="5">
            <a-form-item label="所属单位">
              <a-input placeholder="请输入" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>
          <a-col :span="2" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'教师用户列表-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0,1)" type="primary" v-btnlimit="'教师用户列表-添加'"/>
      <!-- <pxkeji-btn name="下载模版" class="pxkeji_basic_btn" @click="uploadTemplate" type="primary" /> -->
      <!-- <pxkeji-btn name="导出用户" class="pxkeji_basic_btn" @click="uploadExcel(0)" type="primary" /> -->
      <!-- <a-upload
        name="file"
        :action="$api.excel.excelImport(0)"
        :data="{identity:0}"
        accept=".xls"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button>
          <a-icon type="upload" />导入用户
        </a-button>
      </a-upload> -->

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="recommend" slot-scope="recommend">
          <a-tag v-if="recommend==1" color="green">已推荐</a-tag>
          <a-tag v-else color="red">未推荐</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="[]"
            v-btnlimit="'教师用户列表-编辑'"
            @click="showInfo(action.id,2)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />


           <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                    name="删除"
                    :roles="[]"
                    v-btnlimit="'教师用户列表-删除'"
                    @click="delInfo(action.id)"
                    size="small"
                    type="primary"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                    name="解锁"
                    v-btnlimit="'教师用户列表-解锁'"
                    :roles="[]"
                    @click="unlocking(action.id)"
                    size="small"
                    type="dashed"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>教师总数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./teachertInfo.vue"; //新增编辑

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "姓名"
  },
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号"
  },
 /* {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },*/
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "所属单位"
  },
  {
    dataIndex: "title",
    key: "title",
    align: "center",
    title: "职称"
  },
  {
    dataIndex: "recommend",
    key: "recommend",
    align: "center",
    title: "推荐",
    scopedSlots: { customRender: "recommend" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    width: 200,
    scopedSlots: { customRender: "action" }
  }
];
var excelLoading = "";
export default {
  name: "teacherList",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          company: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    unlocking(id) {
      that = this;
      that.isloading = true;
      that.$api.user
          .unlockingUser(id)
          .then(res => {
            that.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              that.$message.success(res.errorMsg);
              that.GetList();
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            that.isloading = false;
          });
    },
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.teacher
        .getPagedList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.company
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "编辑";
      }
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.type = type;
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.teacher
            .deleteById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    },
    uploadTemplate() {
      window.location.href = this.$api.excel.uploadTemplate();
    },
    uploadExcel(id) {
      window.location.href = this.$api.excel.uploadExcel(
        id,
        this.where.keyword.name,
        null,
        null,
        this.where.keyword.company
      );
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleChange(info) {
      if (info.file.status == "uploading") {
        if (excelLoading == "")
          excelLoading = this.$message.loading("上传中", 0);
      } else if (info.file.status == "done") {
        excelLoading();
        excelLoading = "";
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          this.$message.success(info.file.response.errorMsg);
        } else {
          this.$message.error(info.file.response.errorMsg);
        }
      }
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

